import { render, staticRenderFns } from "./SideDrawer.vue?vue&type=template&id=55cfb8be&scoped=true"
import script from "./SideDrawer.vue?vue&type=script&lang=js"
export * from "./SideDrawer.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=55cfb8be&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cfb8be",
  null
  
)

export default component.exports